import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// recuperer tous les cours
export const getAllCourses = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/course/all`, {
    headers: setHeaders(context),
  });
  return response.data;
};

// recuperer un cours via son id
export const getCourseById = async (id_course, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/course/getById/${id_course}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// recuprer tous les cours d'une annee academique
export const getCoursesByAcademicYear = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/course/getAllCourseByYear/${id_academicYear}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// creer un cours
export const createCourse = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/course/create`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// modifier un cours
export const updateCourse = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/course/update/${id}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// supprimer un cours
export const deleteCourse = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/course/delete/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// annuler l'approbation d'un cours
export const cancelApproveCourse = async (id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/course/cancelApprove/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

//creer une association cours-classe
export const createCourseClass = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/courseClass/create`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// modifier une association cours-classe
export const updateCourseClass = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/courseClass/update/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// recuperer une association cours classe via son id
export const getCourseClassById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/courseClass/getById/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// -----------------------------Cours Tracking----------------------------------------------------

// creer un suivis de cours
export const createTracking = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/tracking/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// modifier un suivis de cours
export const updateTracking = async (id_tracking, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/tracking/update/${id_tracking}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// supprimer un suivis de cours
export const deleteTracking = async (id_tracking, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/tracking/delete/${id_tracking}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// recuperer les siuvis d'un cours
export const getTrackingByCourse = async (id_coursVersionEDT, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/tracking/cours/${id_coursVersionEDT}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
